<div class="main-container">
  <div class="ui grid">
    <div class="eleven wide computer column">
      <h1>
        <i class="setting icon"></i>
        Settings
      </h1>
    </div>

    <div class="sixteen wide mobile five wide tablet right floated four wide computer column">
      <a class="ui fluid right floated primary button new-category" 
         v-on:click="newCategory"
         v-if="$store.getters['user/isCatalogEditor']">
        New Category
      </a>
    </div>

    <!-- Sidebar Menu -->
    <div class="sixteen wide mobile four wide tablet four wide computer column settings-side-menu">
      <app-setting-sidebar
              active_tab="category">
      </app-setting-sidebar>
    </div>

    <div class="sixteen wide mobile twelve wide tablet twelve wide computer column settings-main-content">
      <div class="ui top attached tabular menu">
        <div class="item active" data-tab="first">Categories</div>
      </div>

      <!-- Tab 1 -->
      <div class="ui bottom attached tab segment active" data-tab="first">
        <form class="ui form settings">


          <!-- Search and Filters -->
          <div class="search-filters">
            <div class="filter-row">
              <div class="field settings">
                <label>Search Categories</label>
                <div class="ui fluid left icon input">
                  <input 
                    placeholder="Search by name or description" 
                    type="text" 
                    v-model="searchText"
                    v-on:keyup="search">
                  <i class="search icon"></i>
                </div>
              </div>
            </div>
          </div>

          <app-loader v-if="loading"></app-loader>

          <table class="ui basic celled padded table" v-if="!loading && displayRows.length > 0">
            <thead>
            <tr>
              <th class="">Number</th>
              <th class="">Name</th>
              <th class="">Parent</th>
            </tr>
            </thead>
            <tbody>
            <tr
              class="category-row"
              v-for="(row, index) in displayRows"
              :key="row.category.id"
              v-bind:draggable="canReorderCategories"
              v-on:click="viewCategory(row.category)"
              v-on:dragstart="onCategoryDragStart($event, index)"
              v-on:dragend="onCategoryDragEnd"
              v-on:dragover.prevent="onCategoryDragOver($event, index)"
              v-on:dragleave="onCategoryDragLeave($event, index)"
              v-on:drop="onCategoryDrop($event, index)"
              v-bind:class="{
                'sub-category': row.depth === 1,
                'sub-sub-category': row.depth === 2,
                'clickable': $store.getters['user/isCatalogEditor'],
                'category-row--dragging': draggedIndex === index,
                'category-row--drag-over': dragOverIndex === index
              }">
              <td>
                <i class="angle right icon" v-if="row.depth >= 1"></i>
                <i class="angle right icon" v-if="row.depth >= 2"></i>
                {{ rowNumberLabel(row, index) }}
              </td>
              <td>
                <strong v-if="row.depth === 0">{{ row.category.name }}</strong>
                <span v-else class="ui text muted">{{ row.category.name }}</span>
                <span v-if="row.category.description" class="ui text muted">
                  <br><small>{{ row.category.description }}</small>
                </span>
              </td>
              <td>{{ row.parentName || '-' }}</td>
            </tr>
            </tbody>
          </table>

          <!-- Empty State -->
          <div v-if="!loading && displayRows.length === 0" class="ui placeholder segment">
            <div class="ui icon header">
              <i class="folder open outline icon"></i>
              <div class="content">
                No categories found
                <div class="sub header">
                  <span v-if="searchText">
                    Try adjusting your search
                  </span>
                  <span v-else>
                    Get started by creating your first category
                  </span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  

  
  <app-save-category-modal
    v-if="modalVisible"
    :category="category"
    :getCategories="getCategories"
    @close="modalVisible=false">
  </app-save-category-modal>
</div>
